import { ADD_TO_WATCHLIST } from '../../constants';
import GTM from '../gtm/gtm';

const WATCHLIST_QUEUE = 'watchlist-queue';

export default class Queue {

    constructor() {
        this.gtm = new GTM();
    }

    init() {
        this.queues = [WATCHLIST_QUEUE];
    }

    run() {
        if(typeof window.__watchlistQUEUE__ === 'undefined' || window.__watchlistQUEUE__ !== 'disallow' ) {
            for (var i = 0; i < this.queues.length; i++) {
                var elements = JSON.parse(localStorage.getItem(this.queues[i]));
                this.executeAjaxCalls(this.queues[i], elements);
            }
        }
    }

    executeAjaxCalls(queue, elements) {
        if (elements === null || elements.length === 0) {
            // queue is free!
            localStorage.removeItem(queue);
            return;
        }

        var el = elements.pop();
        localStorage.setItem(queue, JSON.stringify(elements));

        // switch, for future operations...
        switch (el.operation) {
        case 'save':
            var that = this;
            $.ajax({
                type: 'post',
                url: el.endpoint,
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                headers: {
                    'X-CSRF-Token': $('meta[name="_csrf"]').attr('content')
                },
                data: JSON.stringify({
                    'id': el.objId
                }),
                success: () => {
                    that.executeDomCalls(el);
                },
                error: () => {

                },
                statusCode: {
                    200: function() {
                        if(typeof el.gtm !== 'undefined') {
                            that.gtm.trackEvent(el.gtm.eventName, el.gtm.eventLabel);
                        }
                        that.executeDomCalls(el);
                    },
                    201: function() {
                        if(typeof el.gtm !== 'undefined') {
                            that.gtm.trackEvent(el.gtm.eventName, el.gtm.eventLabel);
                        }
                        that.addToWatchilstCstEvt();  // dispatch addToWatchlist custom event
                        that.executeDomCalls(el);
                    }
                },
            });
            break;
        }
    }

    executeDomCalls(el) {
        $(document).ready(function() {
            $('.' + el.dom.show).removeClass('hidden');
            $('.' + el.dom.hide).addClass('hidden');
            window.location.hash = el.objId;
        });
    }

    addToWatchilstCstEvt() {
        const event = new CustomEvent(ADD_TO_WATCHLIST);
        document.dispatchEvent(event);
    }

}
